<template>
  <div class="flex md12">
    <span>
      <va-button-group class="flex md12">
        <div class="flex md2">
          <va-button color="info" @click="toCreate">Create Form</va-button>
        </div>
        <div class="flex md2">
          <va-button color="info" @click="showModal = true"
            >Find Form</va-button
          >
        </div>
      </va-button-group>
      <search-modal
        @closeModal="showModal = false"
        :filterFormsModal="showModal"
      ></search-modal>
    </span>
  </div>
</template>

<script>
import searchModal from "./SearchModal.vue";
export default {
  data() {
    return {
      showModal: false
    };
  },
  methods: {
    toCreate() {
      this.$router.push({ name: "createForm" });
    },
    print() {
      alert("ok");
    },
    submit() {},
    cancel() {}
  },
  components: {
    searchModal
  }
};
</script>
